"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ReactVideoPlayer;
var react_1 = __importStar(require("react"));
var lazy_1 = __importDefault(require("react-player/lazy"));
// @ts-ignore
var web_events_1 = require("web/utils/web.events");
function ReactVideoPlayer(_a) {
    var url = _a.url, _b = _a.onEnded, onEnded = _b === void 0 ? function () { } : _b, _c = _a.onError, onError = _c === void 0 ? function () { } : _c, _d = _a.loop, loop = _d === void 0 ? false : _d;
    var _e = (0, react_1.useState)(true), playing = _e[0], setPlaying = _e[1];
    var onVideoError = function (error) {
        // @ts-ignore
        onError(error, { videoUrl: url });
    };
    (0, react_1.useEffect)(function () {
        var handleKeyUp = function (e) {
            if (e.keyCode === web_events_1.amazon.playPause || e.keyCode === web_events_1.keyboard.p) {
                setPlaying(!playing);
            }
        };
        document.addEventListener('keyup', handleKeyUp);
        return function () { return document.removeEventListener('keyup', handleKeyUp); };
    }, [setPlaying, playing]);
    return (react_1.default.createElement(lazy_1.default, { config: {
            youtube: {
                playerVars: { autoplay: 1 },
            },
        }, url: url, loop: loop, width: "100%", height: "100%", playing: playing, onEnded: onEnded, onError: onVideoError, controls: true }));
}
